import {
  Component,
  OnInit,
  AfterViewInit,
  PLATFORM_ID,
  LOCALE_ID,
  Inject
} from "@angular/core";
import { ProjectService } from "../../service/project.service";
import { FacadeService } from "../../service/facade.service";

@Component({
  selector: "app-projects",
  templateUrl: "./projects.component.html",
  styleUrls: ["./projects.component.scss"]
})
export class ProjectsComponent implements OnInit, AfterViewInit {
  logos;
  carousel;
  currenLng: string;
  afterLoad: Boolean = false;
  image;
  img;
  title;
  Title;
  description;
  url;
  projects: string;
  constructor(
    private _facade: FacadeService,
    @Inject(LOCALE_ID) local,
    @Inject(PLATFORM_ID) private platfromId
  ) {
    this._facade.AppLanguage.currentLanguage.subscribe(
      lang => (this.currenLng = lang)
    );
  }

  ngOnInit() {
    this.getLogos();
  }

  ngAfterViewInit() {
    this.afterLoad = true;
    // this.setSeoTagsProperties();
    // this.setSeoTags(this.projects, this.description, '', location.href, location.pathname);
  }
  getLogos() {
    this._facade.ProjectService.getlogos().subscribe(res => {
      this.logos = res.data;

      this.getCarousel();
    });
  }

  getCarousel() {
    this._facade.ProjectService.getcarousel().subscribe(data => {
      this.carousel = data.data;
    });
  }
}
